<template>
    <modal :show.sync="modals.modal1" footerClasses="text-right" :largeModal="true">
    <h6
      slot="header"
      class="modal-title text-success font-weight-bold"
      id="modal-title-default"
    >Panduan E-BPHTB Kota Tarakan</h6>

        <div class="row">
            <div class="col-md-4 col-12 card-bphtb">
                <card class="border-0 d-flex" hover shadow
                    body-classes="text-left align-items-center d-flex justify-content-center">
                    <component :is="'a'">
                        <h6 class="text-black text-uppercase text-bold">
                            1. Login pada sistem E-BPHTB
                        </h6>
                        <object type="image" class="text-black card-pajak">
                            <img class="img-button" src="/img/icons/6343825.jpg" />
                        </object>
                        <p>
                            Wajib Pajak/PPAT melakukan login ke https://bphtb.tarakankota.go.id dan tekan tombol Login /
                            Registrasi Akun jika belum memiliki akun
                            BPPHTB
                        </p>
                    </component>
                </card>
            </div>


            <div class="col-md-4 col-12 card-bphtb">
                <card class="border-0 d-flex" hover shadow
                    body-classes="text-left align-items-center d-flex justify-content-center">
                    <component :is="'a'">
                        <h6 class="text-black text-uppercase text-bold">
                            2. Isi Form SSPD BPHTB
                        </h6>
                        <object type="image" class="text-black card-pajak">
                            <img class="img-button"
                                src="/img/icons/5097611.jpg" />
                        </object>
                        <p>
                            Wajib Pajak / PPAT dapat isi Form SSPD BPHTB. ke https://bphtb.tarakankota.go.id dan tekan
                            tombol <b>Input BPHTB</b>.
                        </p>
                    </component>
                </card>
            </div>


            <div class="col-md-4 col-12 card-bphtb">
                <card class="border-0 d-flex" hover shadow
                    body-classes="text-left align-items-center d-flex justify-content-center">
                    <component :is="'a'">
                        <h6 class="text-black text-uppercase text-bold">
                            3. Masukkan dan Cek Tagihan PBB-P2
                        </h6>
                        <object type="image" class="text-black card-pajak">
                            <img class="img-button" src="/img/icons/7495401.jpg" />
                        </object>
                        <p>
                            Wajib Pajak / PPAT memasukkan NOP PBB-P2 yang akan ditransaksikan BPHTB. Sistem secara
                            otomatis melakukan pengecekan tagihan PBB-P2. Bila ditemukan tagihan PBB-P2 maka tagihan
                            tersebut harus di lunasi terlebih dahulu sebelum melakukan transaksi BPHTB.
                        </p>
                    </component>
                </card>
            </div>


            <div class="col-md-4 col-12 card-bphtb">
                <card class="border-0 d-flex" hover shadow
                    body-classes="text-left align-items-center d-flex justify-content-center">
                    <component :is="'a'">
                        <h6 class="text-black text-uppercase text-bold">
                            4. Proses Verifikasi Petugas
                        </h6>
                        <object type="image" class="text-black card-pajak">
                            <img class="img-button" src="/img/icons/20944105-min.jpg" />
                        </object>
                        <p>
                            Petugas BKPAD akan melakukan Verifikasi terhadap berkas SSPD BPHTB secara elektronik.
                        </p>
                    </component>
                </card>
            </div>

            

            <div class="col-md-4 col-12 card-bphtb">
                <card class="border-0 d-flex" hover shadow
                    body-classes="text-left align-items-center d-flex justify-content-center">
                    <component :is="'a'">
                        <h6 class="text-black text-uppercase text-bold">
                            5. Proses Pembayaran
                        </h6>
                        <object type="image" class="text-black card-pajak">
                            <img class="img-button" src="/img/icons/6134225.jpg" />
                        </object>
                        <p>
                            Wajib Pajak / PPAT Membayar melalui Kanal Pembayaran yang telah bekerja sama dengan BKPAD Kota Tarakan.
                        </p>
                    </component>
                </card>
            </div>



            <div class="col-md-4 col-12 card-bphtb">
                <card class="border-0 d-flex" hover shadow
                    body-classes="text-left align-items-center d-flex justify-content-center">
                    <component :is="'a'">
                        <h6 class="text-black text-uppercase text-bold">
                            6. Cetak SSPD
                        </h6>
                        <object type="image" class="text-black card-pajak">
                            <img class="img-button" src="/img/icons/3572626.jpg" />
                        </object>
                        <p>
                            SSPD BPHTB Elektronik Terverifikasi dapat dicetak.
                        </p>
                    </component>
                </card>
            </div>


        </div>
    </modal>
</template>
  
<script>
import Modal from "@/components/Modal.vue";

export default {
    components: {
        Modal,
    },
    data() {
        return {
            modals: {
                modal1: false,
            },
        };
    },
    methods: {
        showModal() {
            this.modals.modal1 = true;
        },
    },
};
</script>
<style lang="scss" scoped>

</style>